<template>
    <transition name="panels-header" appear>
        <div class="generator__panels__header">
            <template v-if="currentPanel < 3">
                <v-touch @swipe="onPanelHeaderSwipe">
                    <div class="list-wrapper" :class="'panel-' + currentPanel">
                        <ul>
                            <li v-for="(panel, index) in panels"
                                :class="index === currentPanel ? 'is-active' : ''"
                                @click="panelChange(index)">
                                <span class="panel-name">
                                    {{ panel.name }}
                                </span>
                            </li>
                        </ul>
                    </div>

                    <div class="buttons" :class="currentPanel == 2 ? 'buttons--finish' : ''">
                        <template v-if="currentPanel > 0">
                            <button class="button button-prev button--primary button--arrow button--arrow-centered button--arrow-prev button--border"
                                    @click="panelChange('prev')"></button>
                        </template>

                        <button class="button button--secondary button--arrow button--arrow-centered button--border"
                                :class="currentPanel == 2 ? 'button--finish' : ''"
                                @click="panelChange('next')" v-if="currentPanel < 3">
                        </button>
                    </div>
                </v-touch>
            </template>
        </div>
    </transition>
</template>

<script>
    export default {
        props: ['currentPanel', 'panels'],
        methods: {
            panelChange(direction) {
                this.eventHub.$emit('panelChange', direction);
            },
            onPanelHeaderSwipe(event) {
                if (event.direction == 2) {         // left
                    this.panelChange('next');
                } else if (event.direction == 4) {  // right
                    this.panelChange('prev');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/animations/sliding';
    @import '../../assets/scss/dimensions';

    .generator__panels__header {
        display: flex;
        flex-direction: column;
        position: absolute;
        width: 100%;
        z-index: 20;

        @media (min-width: 1024px) {
            position: relative;
            margin-top: 100px;
            max-width: 717px;
            z-index: 1
        }

        @media (min-width: 1680px) {
            margin-top: 166px;
        }
    }

    .list-wrapper {
        transition: transform .5s linear;

        &.panel-0 {
            @media (min-width: 400px) {
                transform: translateX(33vw);
            }

            @media (min-width: 1024px) {
                transform: translateX(-5px);

                .is-active {
                    width: 205px;
                }
            }

            @media (min-width: 1680px) {
                transform: translateX(-10px);

                .is-active {
                    width: 400px;
                }
            }
        }

        &.panel-1 {
            transform: translateX(-100vw);

            @media (min-width: 400px) {
                transform: translateX(0);
            }

            @media (min-width: 1024px) {
                transform: translateX(-116px);

                .is-active {
                    width: 213px;
                }
            }

            @media (min-width: 1680px) {
                transform: translateX(-161px);

                .is-active {
                    width: 423px;
                }
            }
        }

        &.panel-2 {
            transform: translateX(-200vw);

            @media (min-width: 400px) {
                transform: translateX(-33vw);
            }

            @media (min-width: 1024px) {
                transform: translateX(-225px);

                .is-active {
                    width: 187px;
                }

                li:first-child {
                    opacity: 0;
                }

            }

            @media (min-width: 1680px) {
                transform: translateX(-311px);

                .is-active {
                    width: 370px;
                }
            }
        }
    }

    ul {
        display: inline-block;
        height: 50px;
        list-style-type: none;
        margin: 0;
        padding: 0;
        text-align: center;
        transition: transform .5s linear;
        width: 300vw;

        @media (min-width: 400px) {
            width: 100%;
        }

        @media (min-width: 1024px) {
            height: 80px;
            text-align: left;
            width: 850px;
        }

        li {
            display: inline-block;
            height: 50px;
            font-size: 18px;
            line-height: 1em;
            margin: 0;
            opacity: 0.5;
            padding: 0;
            position: relative;
            transition: all linear .5s;
            width: 100vw;
            //width: 33.3%;

            @media (min-width: 400px) {
                font-size: 24px;
                width: 33vw;
            }

            @media (min-width: 1024px) {
                height: 80px;
                margin-right: 25px;
                width: 85px;
            }

            @media (min-width: 1680px) {
                font-size: 37px;
                width: 125px;
            }

            &.is-active {
                font-size: 26px;
                opacity: 1;

                @media (min-width: 400px) {
                    font-size: 33px;
                }

                @media (min-width: 1024px) {
                    font-size: 64px;
                    margin-right: 24px;
                    width: auto;
                }

                @media (min-width: 1680px) {
                    font-size: 127px;
                    line-height: 113px;
                    margin-right: 24px;
                }
            }

            .panel-name {
                cursor: pointer;
                display: block;
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);

                @media (min-width: 1024px) {
                    left: 0;
                    transform: translateX(0);
                }
            }
        }
    }

    .buttons {
        display: none;

        @media (min-width: 1024px) {
            display: inline-block;
            position: absolute;
            bottom: 2px;
            right: 0;
            max-width: 100px;
            transition: all .25s linear;
            text-align: right;
            z-index: 20;

            .button {
                border: 1px solid #FFF;
                border-radius: 4px;
                height: 40px;
                padding: 0;
                transition: width .25s linear, background-color .2s linear;
                width: 40px;

                &:hover {
                    background-color: #DDDDDD;
                }

                &.button-prev {
                    margin-right: 10px;

                    &:hover {
                        background-color: #444444;
                    }

                }

                &--finish {
                    background: #FFF url('../../assets/finish.svg') center left 10px no-repeat;
                    width: 120px;

                    &::after {
                        left: auto;
                        right: 5px;
                    }
                }
            }

            &--finish {
                max-width: 175px;
            }
        }
    }

    // Animations
    .panels-header-enter-active {
        animation: slideToLeftIn 1s ease-out forwards;
    }
</style>


// WEBPACK FOOTER //
// src/components/panels/Header.vue